export default [
  {
    path: "/Contractrelease/Voidreply",
    name: "Voidreply",
    component: () =>
      import("@/views/pages/Contractrelease/Voidreply/Voidreply.vue"),
    props: true,

    meta: {
      pageTitle: "合約作廢回復",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Idstorage",
    name: "Idstorage",
    component: () =>
      import("@/views/pages/Contractrelease/Idstorage/Idstorage.vue"),
    props: true,

    meta: {
      pageTitle: "合約流水號入庫",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Applysearch",
    name: "Applysearch",
    component: () =>
      import("@/views/pages/Contractrelease/Applysearch/Applysearch.vue"),
    props: true,

    meta: {
      pageTitle: "合約申請及查詢",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Checkact",
    name: "Checkact",
    component: () =>
      import("@/views/pages/Contractrelease/Checkact/Checkact.vue"),
    props: true,

    meta: {
      pageTitle: "合約檢核作業",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Sentact",
    name: "Sentact",
    component: () =>
      import("@/views/pages/Contractrelease/Sentact/Sentact.vue"),
    props: true,

    meta: {
      pageTitle: "合約寄送作業",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Distributeact",
    name: "Distributeact",
    component: () =>
      import("@/views/pages/Contractrelease/Distributeact/Distributeact.vue"),
    props: true,

    meta: {
      pageTitle: "合約發放作業",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Storagesearch",
    name: "Storagesearch",
    component: () =>
      import("@/views/pages/Contractrelease/Storagesearch/Storagesearch.vue"),
    props: true,

    meta: {
      pageTitle: "合約庫存查詢",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Voidact",
    name: "Voidact",
    component: () =>
      import("@/views/pages/Contractrelease/Voidact/Voidact.vue"),
    props: true,

    meta: {
      pageTitle: "合約回收/作廢",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Contractsearch",
    name: "Contractsearch",
    component: () =>
      import("@/views/pages/Contractrelease/Contractsearch/Contractsearch.vue"),
    props: true,

    meta: {
      pageTitle: "合約歷程查詢",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Hbhousingreturn",
    name: "Hbhousingreturn",
    component: () =>
      import(
        "@/views/pages/Contractrelease/Hbhousingreturn/Hbhousingreturn.vue"
      ),
    props: true,

    meta: {
      pageTitle: "住商回報表",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Contractldagent",
    name: "Contractldagent",
    component: () =>
      import(
        "@/views/pages/Contractrelease/Contractldagent/Contractldagent.vue"
      ),
    props: true,

    meta: {
      pageTitle: "合約代書維護",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/Ldagentexport",
    name: "Ldagentexport",
    component: () =>
      import("@/views/pages/Contractrelease/Ldagentexport/Ldagentexport.vue"),
    props: true,

    meta: {
      pageTitle: "代書庫存匯出",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Contractrelease/ExportVirtualAccount",
    name: "ExportVirtualAccount",
    component: () =>
      import(
        "@/views/pages/Contractrelease/ExportVirtualAccount/ExportVirtualAccount.vue"
      ),
    props: true,

    meta: {
      pageTitle: "虛擬帳戶匯出",
      breadcrumb: [
        {
          text: "合約發放作業",
          active: true,
        },
      ],
    },
  },
];
